import { Col, DatePicker, Input, Row } from 'antd';
import moment from 'moment';
import { useIntl } from 'react-intl';

import { DiagnosticsQuery } from '@/core/domain/workorder/Diagnostics/Diagnostics.types';

import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';

import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';

function DiagnosticsExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<DiagnosticsQuery>) {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={10}>
        <Input
          value={queryParams?.customer}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, customer: value }))
          }
          placeholder={intl.formatMessage({
            id: 'diagnostics.list.header.customer',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <DatePicker
          format="DD/MM/YYYY"
          style={{ width: '100%' }}
          value={queryParams?.date ? moment(queryParams?.date) : undefined}
          onChange={(value) =>
            setQueryParams((prev) => ({ ...prev, date: value?.toISOString() }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <Input
          value={queryParams?.licensePlate}
          onChange={({ target: { value } }) =>
            setQueryParams((prev) => ({ ...prev, licensePlate: value }))
          }
          placeholder={intl.formatMessage({
            id: 'diagnostics.list.header.plate',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default DiagnosticsExtraFilters;
